export default Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
});